// extracted by mini-css-extract-plugin
export default {"flexTextarea":"styles_flexTextarea__272j0","textarea":"styles_textarea__C-4vL"};